import type {FC} from "react"
import {css, cx} from "styled-system/css"

import AyaHalo from "~/images/aya-halo.svg?react"
import AyaPlain from "~/images/aya-plain.svg?react"

// The halo ellipse in the SVG is filled with currentColor, so its
// color is set through the CSS color property
const haloColorStyles = {
  default: css({color: "#F0EEEB"}),
  white: css({color: "white"}),
}

interface Props {
  width?: number
  direction?: "left" | "right"
  halo?: boolean
  haloColor?: keyof typeof haloColorStyles
  className?: string
}

export const AyaLogo: FC<Props> = ({
  width = 97,
  direction = "right",
  halo = false,
  haloColor = "default",
  className,
}) => {
  const Logo = halo ? AyaHalo : AyaPlain

  return (
    <Logo
      width={width}
      className={cx(
        css({
          flexShrink: 0,
          transform: direction === "right" ? "scaleX(-1)" : undefined,
        }),
        halo ? haloColorStyles[haloColor] : undefined,
        className,
      )}
    />
  )
}
